import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgExtracted = (props: ToothSvgComponentProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17 * (props.wx ?? 1)}
    height={27 * (props.hx ?? 1)}
    viewBox="0 0 17 27"
    fill="none"
    className={props.className}
  >
    <path
      fill="none"
      stroke={props.stroke || '#A1A1AA'}
      strokeDasharray="1.48 0.74"
      strokeLinejoin="round"
      d="M8.348 1.805c-1.333 0-4.799-1.923-6.801.176-1.604 1.683-1.012 5.73.138 8.454.428 1.013.41 2.269.324 3.443-.344 4.702 1.19 11.94 2.592 11.856 1.438-.088 1.309-8.708 3.48-9.46 1.268-.439 1.563 1.821 1.845 3.938.336 2.532.138 5.176.854 5.448.833.315 2.413-1.805 3.253-5.656.451-2.07.646-4.408.589-6.097-.037-1.094-.039-2.459.39-3.472 1.15-2.723 1.742-6.77.137-8.453-2.002-2.1-5.469-.177-6.801-.177Z"
    />
  </svg>
);
export default SvgExtracted;
